export default "__VITE_ASSET__CqYZaIjY__"